<template>
  <div class="mobile-navigation">
    <nav class="offcanvas-navigation" id="offcanvas-navigation">
      <ul>
        <li>
          <router-link to="/contact">تماس با ما</router-link>
        </li>
        <li
          v-for="item in getMenuItems"
          :key="item.id"
          v-bind:class="{
            'menu-item-has-children': item.children.length,
          }"
        >
          <router-link :to="menuItemLink(item)">{{ item.name }}</router-link>
          <ul v-if="item.children.length > 0" class="submenu">
            <li v-for="child in item.children" :key="child.id">
              <router-link :to="menuItemLink(child)">{{
                child.name
              }}</router-link>
            </li>
          </ul>
        </li>

        <!-- <li class="menu-item-has-children">
          <router-link to="/">خانه</router-link>
          <ul class="sub-menu">
            <li>
              <router-link to="/">خانه 1</router-link>
            </li>
            <li>
              <router-link to="/home-two">خانه 2</router-link>
            </li>
            <li>
              <router-link to="/home-three">خانه 3</router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/about">درباره ما</router-link>
        </li>
        <li class="menu-item-has-children">
          <router-link to="/service">خدمات ما</router-link>
          <ul class="sub-menu">
            <li>
              <router-link to="/service">خدمات ما</router-link>
            </li>
            <li>
              <router-link to="/service-details">جزئیات خدمات</router-link>
            </li>
            <li>
              <router-link to="/service-details-right"
                >جزئیات خدمات با ستون چپ</router-link
              >
            </li>
          </ul>
        </li>
        <li class="menu-item-has-children">
          <router-link to="/project">پروژه ها</router-link>
          <ul class="sub-menu">
            <li>
              <router-link to="/project">پروژه ها</router-link>
            </li>
            <li>
              <router-link to="/project-details">جزئیات پروژه ها</router-link>
            </li>
          </ul>
        </li>
        <li class="menu-item-has-children">
          <router-link to="/blog-left-sidebar">وبلاگ</router-link>
          <ul class="sub-menu">
            <li>
              <router-link to="/blog-left-sidebar"
                >وبلاگ با ستون راست</router-link
              >
            </li>
            <li>
              <router-link to="/blog-right-sidebar"
                >وبلاگ با ستون چپ</router-link
              >
            </li>
            <li>
              <router-link to="/blog-details">جزئیات وبلاگ</router-link>
            </li>
            <li>
              <router-link to="/blog-details-right-sidebar"
                >جزئیات وبلاگ با ستون چپ</router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/contact">تماس با ما</router-link>
        </li> -->
      </ul>
    </nav>
  </div>
</template>

<script>
import { menuItemStore } from "@/store/Modules/menuItem.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
export default {
  name: "MobileNavMenu",
  computed: {
    ...mapState(menuItemStore, ["getMenuItems"]),
  },
  methods: {
    ...mapActions(menuItemStore, ["getMenuItemsAction"]),
    // offcanvas mobilemenu

    menuItemLink(item) {
      if (item.type == "internal_link") {
        return item.link
      }
      return "#"
    },
  },
  mounted() {
    this.getMenuItemsAction()

    const offCanvasNav = document.querySelector("#offcanvas-navigation")
    const offCanvasNavSubMenu = offCanvasNav.querySelectorAll(".sub-menu")
    const anchorLinks = offCanvasNav.querySelectorAll("a")

    for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
      offCanvasNavSubMenu[i].insertAdjacentHTML(
        "beforebegin",
        "<span class='menu-expand'><i></i></span>"
      )
    }

    const menuExpand = offCanvasNav.querySelectorAll(".menu-expand")
    const numMenuExpand = menuExpand.length

    for (let i = 0; i < numMenuExpand; i++) {
      menuExpand[i].addEventListener("click", (e) => {
        sideMenuExpand(e)
      })
    }

    for (let i = 0; i < anchorLinks.length; i++) {
      anchorLinks[i].addEventListener("click", () => {
        closeMobileMenu()
      })
    }

    const sideMenuExpand = (e) => {
      e.currentTarget.parentElement.classList.toggle("active")
    }
    const closeMobileMenu = () => {
      const offcanvasMobileMenu = document.querySelector(
        "#offcanvas-mobile-menu"
      )
      offcanvasMobileMenu.classList.remove("active")
    }
  },
}
</script>

<style lang="scss">
@import "../assets/scss/0-base/_variables.scss";

/* offcanvas mobile menu */
.mobile-navigation {
  padding: 30px 20px;
}
.offcanvas-navigation {
  & > ul {
    li {
      &.menu-item-has-children {
        .sub-menu {
          height: 0;
          visibility: hidden;
          opacity: 0;
          transition: 0.3s;
        }
        &.active {
          & > .sub-menu {
            height: 100%;
            visibility: visible;
            opacity: 1;
          }
        }
      }
      & > a {
        color: $white;
        font-size: 14px;
        padding: 10px 0;
        display: block;
        &:hover {
          color: $white;
        }
      }
    }
  }

  ul {
    &.sub-menu {
      margin-right: 25px;
      transition: 0.3s;
      & > li {
        & > a {
          color: $white;
          font-size: 13px;
          padding: 10px 0;
          &:hover {
            color: $white;
          }
        }
      }
    }
    li {
      a {
        text-transform: uppercase;
      }

      &.menu-item-has-children {
        position: relative;
        display: block;
        a {
          display: block;
        }

        &.active {
          & > .menu-expand {
            i {
              &:before {
                transform: rotate(0);
              }
            }
          }
        }

        .menu-expand {
          position: absolute;
          left: auto;
          right: 95%;
          top: -5px;
          width: 30px;
          height: 50px;
          line-height: 50px;
          cursor: pointer;
          text-align: center;

          i {
            display: block;
            margin-top: 27px;
            border-bottom: 1px solid $white;
            position: relative;
            width: 10px;
            transition: all 250ms ease-out;
            &:before {
              width: 100%;
              content: "";
              border-bottom: 1px solid $white;
              display: block;
              position: absolute;
              top: 0;
              transform: rotate(-90deg);
            }
          }
        }
      }
    }
  }
}
</style>
